import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';
import classNames from 'classnames';
import Button from 'carbon-react/lib/components/button';

import { ROUTES, getForecastByIdOnboardingUrl } from '@futrli/shared-services';

import { OnboardingPageTitle } from '../components/onboarding-page-title';
import * as styles from '../forecasting-onboarding.scss';
import { OnboardingPredictionsRouter } from '../components/onboarding-predictions-router';
import imgToggle from '../arrows/toggle-off-prediction-big.png';
import {
  BUDGET_ONBOARDING_STEP,
  LS_FORECASTING_ONBOARDING_STEP,
  SCENARIO_ONBOARDING_STEP,
  SCENARIO_WITH_INVOICES_ONBOARDING_STEP
} from '../const';
import { useAnimationLatency, useExpandAllRows, useOnboardingUrlInfo } from '../utils/hooks';
import { usePredictionsInfoContext } from '../../detail/context/predictions-info-context';

export const OnboardingToggleOff = () => {
  const { forecast } = usePredictionsInfoContext();

  const { workspaceId: tempWorkspaceId, organisationId: tempOrganisatioId } = useParams();
  const workspaceId = tempWorkspaceId || '';
  const organisationId = tempOrganisatioId || '';

  const {
    isOnboardingBudgetRoute,
    isOnboardingScenarioRoute,
    isOnboardingScenarioWithInvoicesRoute
  } = useOnboardingUrlInfo();

  const navigate = useNavigate();

  useExpandAllRows();

  const showAnimatedArrow = useAnimationLatency(true);

  const handleNextClick = () => {
    if (!forecast) {
      return;
    }

    let nextStep;

    if (isOnboardingBudgetRoute) {
      nextStep = BUDGET_ONBOARDING_STEP.LYA_CUSTOMISE;
    } else if (isOnboardingScenarioRoute) {
      nextStep = SCENARIO_ONBOARDING_STEP.LYA_HISTORICAL;
    } else {
      nextStep = SCENARIO_WITH_INVOICES_ONBOARDING_STEP.LYA_HISTORICAL;
    }

    navigate(
      `${getForecastByIdOnboardingUrl(
        workspaceId,
        organisationId,
        forecast.id,
        isOnboardingBudgetRoute,
        isOnboardingScenarioWithInvoicesRoute
      )}/${nextStep}${ROUTES.SALES}${location.search}`
    );
    localStorage.setItem(LS_FORECASTING_ONBOARDING_STEP, nextStep);
  };

  return (
    <div className={styles.contentContainer} style={{ position: 'relative' }}>
      <OnboardingPageTitle
        title={
          <FormattedMessage
            id="onboarding.lya_have_been_applied"
            defaultMessage="Last year’s actuals have been applied. Toggle off any you don’t want...?"
          />
        }
        description={
          <FormattedMessage
            id="onboarding.can_come_back_guided_flow"
            defaultMessage="You can come back to this at the end of this guided flow."
          />
        }
      />
      <Button size="large" buttonType="primary" mb="30px" onClick={handleNextClick} disabled={!forecast}>
        <FormattedMessage id="common.next" defaultMessage="Next" />
      </Button>

      <img
        src={imgToggle}
        alt="toggle prediction"
        style={{ position: 'absolute', top: 85, zIndex: 50, left: 1000 }}
        className={classNames(styles.fadeInContainer, {
          [styles.fadeIn]: showAnimatedArrow
        })}
      />
      <OnboardingPredictionsRouter />
    </div>
  );
};
